// api/v1/masterdata/exam-justification then api/v1/masterdata/exam-justification-icd10 to fill "icd10s" arrays
// Exists in backend too
export const examJustifications = [
    {
        "id": "1",
        "examJustificationGroup": {
            "id": "1",
            "description": "BrCa"
        },
        "description": "Γυναίκα που έχει διάγνωση επιθηλιακού καρκινώματος των ωοθηκών ανεξαρτήτως ηλικίας και οικογενειακού ιστορικού",
        "lookupConf": "",
        "labelConf": "",
        "ageFrom": "",
        "ageTo": "",
        "icd10SelectionCount": "1",
        "questionCount": "",
        "icd10s": ["C56"],
    },
    {
        "id": "2",
        "examJustificationGroup": {
            "id": "1",
            "description": "BrCa"
        },
        "description": "Γυναίκα που έχει διαγνωστεί με Ca μαστού πριν από την ηλικία των 45 ετών",
        "lookupConf": "",
        "labelConf": "",
        "ageFrom": "",
        "ageTo": "45",
        "icd10SelectionCount": "1",
        "questionCount": "",
        "icd10s": ["C50", "C50.0", "C50.1", "C50.2", "C50.3", "C50.4", "C50.5", "C50.6", "C50.8", "C50.9"],
    },
    {
        "id": "3",
        "examJustificationGroup": {
            "id": "1",
            "description": "BrCa"
        },
        "description": "Γυναίκα που έχει διαγνωστεί με Ca μαστού σε οποιαδήποτε ηλικία και έχει τουλάχιστον δύο (2) περιστατικά από την ίδια μεριά της οικογένειας με εμπεριστατωμένη διάγνωση Ca μαστού, ωοθηκών, παγκρέατος ή προστάτη με Gleason score μεγαλύτερο ή ίσο του 7",
        "lookupConf": "BRCA_3_SIDE;BRCA_3_RELATIVE;BRCA_3_HISTORY;BRCA_3_RELATIVE;BRCA_3_HISTORY",
        "labelConf": "Πλευρά Οικογένειας για Ιστορικό;Ιστορικό 1;Οικογενειακό ιστορικό κακοήθους νεοπλάσματος;Ιστορικό 2;Οικογενειακό ιστορικό κακοήθους νεοπλάσματος",
        "ageFrom": "",
        "ageTo": "",
        "icd10SelectionCount": "1",
        "questionCount": "5",
        "icd10s": ["C50", "C50.0", "C50.1", "C50.2", "C50.3", "C50.4", "C50.5", "C50.6", "C50.8", "C50.9"],
    },
    {
        "id": "4",
        "examJustificationGroup": {
            "id": "1",
            "description": "BrCa"
        },
        "description": "Γυναίκα στην οικογένεια της οποίας υπάρχει μετάλλαξη των γονιδίων BRCA 1,2",
        "lookupConf": "BRCA_4_RELATIVE",
        "labelConf": "Συγγενής με Μετάλλαξη",
        "ageFrom": "",
        "ageTo": "",
        "icd10SelectionCount": "1",
        "questionCount": "1",
        "icd10s": ["Z84.3"],
    }
]

export const examJustificationsOptions = examJustifications.map((o) => {
    return {
        value: o.id,
        label: o.description,
    }
})

export const examJustificationAnswers = [
    {
        "id": "3050",
        "lookupConf": "BRCA_4_RELATIVE",
        "value": "MOTHER",
        "abbreviation": "Μητέρα",
        "meaning": "Μητέρα"
    },
    {
        "id": "3051",
        "lookupConf": "BRCA_4_RELATIVE",
        "value": "GRANDMOTHER",
        "abbreviation": "Γιαγιά",
        "meaning": "Γιαγιά"
    },
    {
        "id": "3052",
        "lookupConf": "BRCA_4_RELATIVE",
        "value": "SISTER",
        "abbreviation": "Αδελφή",
        "meaning": "Αδελφή"
    },
    {
        "id": "3000",
        "lookupConf": "BRCA_3_SIDE",
        "value": "FATHER",
        "abbreviation": "Πατέρα",
        "meaning": "Πατέρα"
    },
    {
        "id": "3001",
        "lookupConf": "BRCA_3_SIDE",
        "value": "MOTHER",
        "abbreviation": "Μητέρας",
        "meaning": "Μητέρας"
    },
    {
        "id": "3002",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "FATHER",
        "abbreviation": "Πατέρας",
        "meaning": "Πατέρας"
    },
    {
        "id": "3003",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "MOTHER",
        "abbreviation": "Μητέρα",
        "meaning": "Μητέρα"
    },
    {
        "id": "3004",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "GRANDFATHER",
        "abbreviation": "Παππούς",
        "meaning": "Παππούς"
    },
    {
        "id": "3005",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "GRANDMOTHER",
        "abbreviation": "Γιαγιά",
        "meaning": "Γιαγιά"
    },
    {
        "id": "3006",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "BROTHER",
        "abbreviation": "Αδελφός",
        "meaning": "Αδελφός"
    },
    {
        "id": "3007",
        "lookupConf": "BRCA_3_RELATIVE",
        "value": "SISTER",
        "abbreviation": "Αδελφή",
        "meaning": "Αδελφή"
    },
    {
        "id": "3010",
        "lookupConf": "BRCA_3_HISTORY",
        "value": "Z80.0",
        "abbreviation": "οργάνων του πεπτικού (εάν αφορά στο πάγκρεας)",
        "meaning": "Οικογενειακό ιστορικό κακοήθους νεοπλάσματος των οργάνων του πεπτικού (εάν αφορά στο πάγκρεας)"
    },
    {
        "id": "3011",
        "lookupConf": "BRCA_3_HISTORY",
        "value": "Z80.3",
        "abbreviation": "μαστού (εάν αφορά στο μαστό)",
        "meaning": "Οικογενειακό ιστορικό κακοήθους νεοπλάσματος του μαστού (εάν αφορά στο μαστό)"
    },
    {
        "id": "3012",
        "lookupConf": "BRCA_3_HISTORY",
        "value": "Z80.4",
        "abbreviation": "γεννητικών οργάνων (εάν αφορά στις ωοθήκες)",
        "meaning": "Οικογενειακό ιστορικό κακοήθους νεοπλάσματος των γεννητικών οργάνων (εάν αφορά στις ωοθήκες)"
    },
    {
        "id": "3013",
        "lookupConf": "BRCA_3_HISTORY",
        "value": "Z80.5",
        "abbreviation": "της ουροποιητικής οδού (εάν αφορά στον προστάτη με Gleason sxore >= 7)",
        "meaning": "Οικογενειακό ιστορικό κακοήθους νεοπλάσματος της ουροποιητικής οδού (εάν αφορά στον προστάτη με Gleason sxore >= 7)"
    }
]

